import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudUpload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCloudUpload"><Path d="M5.59824 8.16485C6.68595 5.71241 9.14187 4 12 4C15.5571 4 18.4944 6.65314 18.9412 10.0884C21.2527 10.5287 23 12.5603 23 15C23 17.7614 20.7614 20 18 20H13V14.4142L14.5 15.9142L15.9142 14.5L12 10.5858L8.08579 14.5L9.5 15.9142L11 14.4142V20H7C3.68629 20 1 17.3137 1 14C1 11.1686 2.96041 8.79651 5.59824 8.16485Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloudUpload;
